import { fromJS, Map, List } from "immutable";
import * as actionTypes from "~/store/action_types";

const mergeEntities = (state, projectId, labels) => {
  const projectTaskLabels = new List(state.get(`${projectId}`));

  const labelIds = [];
  labels.forEach((label) => labelIds.push(label.get(`id`)));

  const newLabelIds = labelIds.filter((labelId) => projectTaskLabels && projectTaskLabels.indexOf(labelId) === -1);

  return List([...projectTaskLabels, ...newLabelIds]);
};

const projectTaskLabels = (state = new Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_TASKS_SUCCESS:
    case actionTypes.FETCH_PROJECT_ADDITIONAL_DATA_SUCCESS: {
      const { projectId, response } = action;
      const { label_ids } = response;

      if (projectId && label_ids) {
        return state.set(`${projectId}`, List(label_ids));
      }

      return state;
    }
    case actionTypes.FETCH_PROJECT_SUCCESS: {
      const { response = {} } = action;
      const { result = {}, entities = {} } = response;
      const { projects = {} } = entities;
      const { single: id, label_ids = [] } = result;
      if (projects[id]) {
        const projectTaskLabels = projects[id].task_labels ? projects[id].task_labels : [];
        return state.set(`${id}`, List([...new Set([...projectTaskLabels, ...label_ids])]));
      }
      return state;
    }
    case actionTypes.ANGULAR_INIT_PROJECT_MODAL: {
      if (
        !action.response ||
        !action.response.result ||
        !action.response.result.project ||
        !action.response.entities.projects
      ) {
        return state;
      }
      const projectId = action.response.result.project;
      const labels = action.response.entities.projects[projectId].task_labels;
      let newLabels = state.get(`${projectId}`, List()).concat(List(labels));
      return state.set(`${projectId}`, newLabels);
    }
    case actionTypes.UPDATE_TASK_FROM_EVENT_STREAM:
    case actionTypes.ADD_TASK_FROM_EVENT_STREAM:
    case actionTypes.TASK_MOVED_TO_PROJECT_FROM_EVENT_STREAM:
    case actionTypes.EDIT_TASK_SUCCESS: {
      if (
        !action.response ||
        !action.response.result ||
        !action.response.entities ||
        !action.response.entities.labels
      ) {
        return state;
      }
      if (!action.response.result.single) {
        const taskId = action.response.result;
        const projectId = action.response.entities.tasks[taskId].project_id;
        const labels = action.response.entities.labels;
        return state.set(`${projectId}`, mergeEntities(state, projectId, fromJS(labels)));
      }
      const taskId = action.response.result.single;
      const projectId = action.response.entities.tasks[taskId].project_id;
      const labels = action.response.entities.labels;
      return state.set(`${projectId}`, mergeEntities(state, projectId, fromJS(labels)));
    }
    case actionTypes.LOAD_TASK:
    case actionTypes.ADD_TASK_SUCCESS:
    case actionTypes.BATCH_EDIT_TASKS_SUCCESS: {
      if (!action.response || !action.projectId || !action.response.entities || !action.response.entities.labels) {
        return state;
      }
      const projectId = action.projectId;
      const labels = action.response.entities.labels;
      return state.set(`${projectId}`, mergeEntities(state, projectId, fromJS(labels)));
    }
    case actionTypes.ADD_LABEL_TO_PROJECT: {
      const { projectId, response } = action;
      const { entities, result: labelId } = response;
      const { labels } = entities;

      return state.set(`${projectId}`, mergeEntities(state, projectId, [fromJS(labels[labelId])]));
    }
    default:
      return state;
  }
};

export default projectTaskLabels;
